/* eslint-disable camelcase */

import './SortBy.scss';

import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as digitalData from '@ao-internal/digital-data';

import { sortOptionChanged } from '../../../actions/lister-actions';
import {
	useIsMediumAndAbove,
	useIsXMediumAndAbove,
} from '../../../hooks/mediaQueries';
import TRANSLATIONS from '../../../translations/translations@default.json';
import { scrollToTopOfLister } from '../../../utilities/lister-utilities';
import SortByDefaultOption from './SortByDefaultOption@default';

export const SortBy = ({ sticky, customCatsEnabled, mobile }) => {
	const { sorting } = useSelector((state) => state);

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const isMediumAndAbove = useIsMediumAndAbove();
	const isXMediumAndAbove = useIsXMediumAndAbove();

	const dispatch = useDispatch();

	if (
		!sorting?.AvailableSortOptions ||
		!Array.isArray(sorting.AvailableSortOptions) ||
		!sorting.AvailableSortOptions.length
	) {
		return null;
	}

	const { CurrentSortBy, AvailableSortOptions } = sorting;

	const value = AvailableSortOptions.map((item) => item.SortKey).indexOf(
		CurrentSortBy
	);

	const getSelectedSortOption = AvailableSortOptions.filter((item) => {
		return item.SortKey === CurrentSortBy;
	});

	const handleChange = (event) => {
		if (sorting) {
			const option = sorting.AvailableSortOptions[event.target.value];

			dispatch(sortOptionChanged(option));

			const listerAppContainer = document.querySelector('.lister');

			if (listerAppContainer) {
				const topOfListerAppContainer = listerAppContainer.offsetTop;

				if (topOfListerAppContainer < window.scrollY) {
					scrollToTopOfLister(listerAppContainer);
				}
			}
		}
	};

	const sendTracking = (eventName) => {
		digitalData.sendBeacon('TrackClick', {
			name: eventName,
		});
	};

	return (
		<React.Fragment>
			{((isMediumAndAbove && !CustomCategoriesEnabled) ||
				(isXMediumAndAbove && CustomCategoriesEnabled)) && (
				<span
					id="lister-sort-label"
					className="text-title-sm text-sm mr-2 whitespace-no-wrap"
					data-testid="sort-by-label">
					{TRANSLATIONS.controls.sortBy.sortByLabel}
				</span>
			)}
			<div className="flex w-full c-input-container c-input-container--select">
				<select
					onFocus={() => sendTracking('sortby-opened')}
					onBlur={() => sendTracking('sortby-closed')}
					defaultValue={CurrentSortBy !== null ? value : 'default'}
					onChange={(event) => handleChange(event)}
					aria-label="Sort by"
					className={classnames({
						'text-body-xs u-pr--large bg-white': !mobile,
						'cta btn btn-primary rounded-none': mobile,
						'rounded-l': sticky,
            'text-center sortBy-mob-padding': customCatsEnabled
					})}
					data-testid="sort-by__select"
					data-tag-name="sort-by"
					data-tag-current-sort-by={getSelectedSortOption[0]?.SortPhrase}>
					{CurrentSortBy === null && <SortByDefaultOption />}

					{AvailableSortOptions.map((option, index) => (
						<option
							className={classnames('bg-white', {
								'text-body-sm text-water': mobile,
							})}
							key={option.SortKey}
							value={index}
							label={option.SortPhrase}
							data-testid="sort-by__option">
							{option.SortPhrase}
						</option>
					))}
				</select>

        {!CustomCategoriesEnabled && 
          <div className="text-base">
            <i
              className={classnames(
                'ico ico-chevron-down absolute ico-lg text-lightgreen pointer-events-none',
                {
                  sortby__chevron: CustomCategoriesEnabled,
                  'md:text-cta-action': !CustomCategoriesEnabled,
                }
              )}
              style={{ top: '50%', right: '12px', transform: 'translateY(-50%)' }}
            />
          </div>
        }
			</div>
		</React.Fragment>
	);
};

export default SortBy;
